module.exports = __webpack_public_path__ + "img/back_m_active2.108c0b80.png";